import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const state = {
  selectedOrderID: 0,
  selectedOrderType: 1,
  isNewOrder: false,
  fromOrderSummary: false, // new order: false; coming from order summary: true
}

export const getters = {
  selectedOrderID: (state) => {
    return state.selectedOrderID
  },

  selectedOrderType: (state) => {
    return state.selectedOrderType
  },

  isNewOrder: (state) => {
    return state.isNewOrder
  },

  fromOrderSummary: (state) => {
    return state.fromOrderSummary
  },
}

export const mutations = {
  SET_SELECTED_ORDER_ID(state, value) {
    state.selectedOrderID = value
  },

  SET_SELECTED_ORDER_TYPE(state, value) {
    state.selectedOrderType = value
  },

  SET_IS_NEW_ORDER(state, value) {
    state.isNewOrder = value
  },

  SET_FROM_ORDER_SUMMARY(state, value) {
    state.fromOrderSummary = value
  },
}

export const actions = {
  addForUrl(key, value) {
    return value === null || value === undefined
      ? ''
      : `&${key}=${encodeURIComponent(value)}`
  },
  init({ state, dispatch }) {},

  fetchCustomer({ state }, { pageNumber, pageSize } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getcustomers
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&isActive=1&key=CustomerType&value=customer`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  fetchCustomerProducts({ state }, customerId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.adminApiPath.getcustomerproduct
    }`
    return axios
      .post(url, customerId, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchCustomerById({ state }, { customerId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getcustomerdetails
        }/${customerId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchUserForEdit({ commit }, { userId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getuserforedit
        }/${userId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        commit('SET_UserDetails', response.data)
        return response.data
      })
  },
  fetchCustomerUser({ state }, { customerId, apiVersion } = {}) {
    return axios
      .get(
        apiVersion !== 2
          ? `${appConfig.apiEndPoint}${
              endpoint.adminApiPath.getcustomerusers
            }?CustomerId=${customerId}`
          : `${appConfig.apiEndPoint}${
              endpoint.adminApiPath.getUsersForReport
            }/${customerId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  fetchCreditManagerOrProcessors({ state }, { customerId, roleId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getcustomerusersbyrole
        }?CustomerId=${customerId}&RoleId=${roleId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  fetchBCRCCRDraftReport({ state }, { orderId } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.bcrApiPath.ccrreportorder
        }?orderId=${orderId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchOrderBCIRTrade({ state }, { bcir2JsonData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.bcir}`,
        bcir2JsonData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchSearchCompanyResult({ state }, { searchRequest } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.companysearch}`,
        searchRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchSaveAsDraftMethod({ state }, { ccrDraftRequest } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.ccrreportdraft}`,
        ccrDraftRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchBCRCCROrderReport({ state }, { bcrCCRJsonData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.ccrreport}`,
        bcrCCRJsonData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  async fetchOrderCCRReport({ state }, { requestString } = {}) {
    return axios

      .post(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.orderconsumercreditreport
        }`,
        requestString,
        { headers: setHeaders() }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  fetchOrderSupplementQueue(
    { commit, dispatch, getters },
    {
      pageNumber,
      key,
      sortBy,
      sortDirection,
      startTime,
      endTime,
      timeZone,
      isBranch,
      pageSize,
      value,
      userId,
      customerId,
      role,
      File,
      RequestId,
      applicantName,
      OrderedFor,
      Rush,
      ProcessorName,
      Request,
      RequestStatus,
      isAdvanceSearch,
    } = {}
  ) {
    var url = ''
    if (isAdvanceSearch) {
      url =
        appConfig.apiEndPoint +
        endpoint.ccrLobApiPath.myqueueAdvancedSearch +
        '?PageSize=' +
        pageSize +
        actions.addForUrl('PageNumber', pageNumber) +
        actions.addForUrl('Key', 'All') +
        actions.addForUrl('FromDate', startTime) +
        actions.addForUrl('ToDate', endTime) +
        actions.addForUrl('File', File) +
        actions.addForUrl('RequestId', RequestId) +
        actions.addForUrl('applicantName', applicantName) +
        actions.addForUrl('OrderedFor', OrderedFor) +
        actions.addForUrl('CustomerId', customerId) +
        actions.addForUrl('Rush', Rush) +
        actions.addForUrl('ProcessorName', ProcessorName) +
        actions.addForUrl('Request', Request) +
        actions.addForUrl('RequestStatus', RequestStatus) +
        actions.addForUrl('isBranch', isBranch) +
        actions.addForUrl('userId', userId) +
        actions.addForUrl('role', role) +
        actions.addForUrl('SortBy', sortBy) +
        actions.addForUrl('SortDirection', sortDirection)
    } else {
      url =
        appConfig.apiEndPoint +
        endpoint.ccrLobApiPath.myqueueSimpleSearch +
        '?PageSize=' +
        pageSize +
        actions.addForUrl('PageNumber', pageNumber) +
        actions.addForUrl('key', key) +
        actions.addForUrl('SortBy', sortBy) +
        actions.addForUrl('sortDirection', sortDirection) +
        actions.addForUrl('FromDate', startTime) +
        actions.addForUrl('ToDate', endTime) +
        actions.addForUrl('isBranch', isBranch) +
        actions.addForUrl('userId', userId) +
        actions.addForUrl('role', role) +
        actions.addForUrl('value', value)
    }
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        const activityReport = response.data
        // commit('SET_ACTIVITYREPORT', activityReport)

        return activityReport
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          // commit('SET_ACTIVITYREPORT', null)
        }
        return null
      })
  },

  updateMyQueue({ state }, { requestString } = {}) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.updateMyQueue}`,
        requestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  updateMyQueueList({ state }, { requestString } = {}) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.updateMyQueueList}`,
        requestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  saveOrderSupplementQueue({ state }, { requestString } = {}) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.ordersupplementqueue
        }`,
        requestString,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchOrderSupplement({ state }, { orderId, byUserId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.ordersupplimentcreditreport
        }/${orderId}/${byUserId}`,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  submitRescoreRequest({ state }, { requestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.rescoreRequest}`,
        requestString,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchRescore({ state }, { orderId, byUserId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.rescoreRequest
        }/${orderId}/${byUserId}`,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchRescoreProcessor({ state }, { rescoreId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.rescoreProcessor
        }/${rescoreId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchFaxIntegration({ state }, { rescoreId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.endpointFaxIntegration
        }/${rescoreId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  submitFaxIntegration({ state }, { requestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.endpointFaxIntegration
        }`,
        requestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  previewFaxIntegration({ state }, { requestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.endpointFaxPreview}`,
        requestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  rescoreRepullRequest({ state }, { rescoreId, userId } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.rescoreRepullRequest
        }?rescoreId=${rescoreId}&byUserId=${userId}`,
        null,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  submitRescoreProcessor({ state }, { requestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.rescoreProcessor}`,
        requestString,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  async getRescoreDocument({ commit }, { documentId, groupId }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.ccrLobApiPath.rescoreFile
    }/${documentId}/${!!groupId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  // New method for fetch edit supplement - start
  fetchOrderEditSupplement({ state }, { requestNumber, parentRequestId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.editsupplementorderreport
        }/${requestNumber}/${parentRequestId}`,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  // New method for fetch edit supplement - ends

  // New method for put -save edit supplement -start

  updateEditSupplement({ state }, { requestString } = {}) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.editsupplementorderreport
        }`,
        requestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  // New method for put -save edit supplement -ends

  saveOrderSupplement({ state }, { requestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.ordersupplimentcreditreport
        }`,
        requestString,
        {
          headers: setHeaders(),
        }
      )

      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchCCRSummaryData({ state }, { orderId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getordersummaryccr
        }/${orderId}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchUserProduct({ state }, { userId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getCustomerUserProducts
        }?UserId=${userId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  fetchServicelinkFloodReport({ state }, { jsonRequestString }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.servicelinkfloodreport}`,
        jsonRequestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchFloodReport({ state }, { jsonRequestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.floodreport}`,
        jsonRequestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  deleteAuthorizationForm({ state }, { orderId, reportId } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.bcrApiPath.delete
        }?OrderId=${orderId}&ProductId=${reportId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },

  uploadForm({ state }, { fileDetails } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.upload}`,
        fileDetails,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },

  async checkReportExpiryTime({ commit }, reportID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.checkReportExpiryTime
        }/${reportID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getCCROrderData({ commit }, reportID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getCCROrderData
        }/${reportID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getPDFForRemove({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.getPDFForRemove}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getSupplementDocument({ commit }, documentId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.ccrLobApiPath.getSupplementDocument
    }/${documentId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async GetPDFForSupplement({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.GetPDFForSupplement}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async orderReportForRemove({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.orderReportForRemove
        }`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  fetchPrintSupplementReport({ commit }, payload) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.ccrLobApiPath.PrintSupplementReport
    }`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  async getRequesterInfo({ commit }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getRequesterInfo
        }/${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getCustomerList({ commit }, productID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getCustomerList
        }/${productID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getUserList({ commit }, customerID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getUserList
        }/${customerID}/52`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async updateRequester({ commit }, payload) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.updateRequester}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async fetchOrderLimits({ commit }, limitData) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.ccrLobApiPath.GetOrderCount}/${
          limitData.customerUser
        }`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getOrderLinkStatus({ commit }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getOrderLinkStatus
        }/${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  setFromOrderSummary({ commit }, fromOrderSummary = false) {
    commit('SET_FROM_ORDER_SUMMARY', fromOrderSummary)
  },

  setOrderReportFlow({ commit }, orderId = 0, orderType = 1) {
    commit('SET_SELECTED_ORDER_ID', orderId)
    commit('SET_SELECTED_ORDER_TYPE', orderType)
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    // axios.defaults.headers.common.Authorization.substring(0, 6) !== 'Bearer'
    //   ? `Bearer ${axios.defaults.headers.common.Authorization}`
    //   : axios.defaults.headers.common.Authorization,
  }
}
